import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const OldInspectionDetailsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.OLD_INSPECTION_DETAILS}
      isSubSection={true}
      icon={'Folder_navy.svg'}
      label={<FormattedMessage id="old-inspection-details-page-link" defaultMessage="Old inspection details"/>}
    />
  );
};

export default OldInspectionDetailsLink;
